module.exports = __webpack_public_path__ + "img/IMG_2460.9407f278.jpeg";